import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { ChatWidgetComponent } from './chat-widget.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { AssistedBrowsingModule } from '../shared/components/assisted-browsing-panel/assisted-browsing.module';
import { ChatBoxModule } from './chat-box/chat-box.module';
import { NanorepPanelModule } from 'shared/components/nanorep-panel/nanorep-panel.module';
import { CannedMessageModule } from 'shared/components/canned-message-panel/canned-message-panel.module';
import { DiscussionsModule } from 'shared/components/discussions/discussions.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { RefreshableFrameModule } from 'shared/components/refreshable-frame/refreshable-frame.module';
import { SalesforceLaneModule } from 'shared/components/salesforce-lane/salesforce-lane.module';
import { RemoteControlPanelModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/chat-widget/remote-control-panel/remote-control-panel.module';
import { DetailedDataModule } from 'shared/components/detailed-data/detailed-data.module';
import { AssignmentHistoryModule } from 'shared/components/assignment-history/assignment-history.module';
import { SmartAdvisorModule } from 'shared/components/smart-advisor/smart-advisor.module';
import { SmartAdvisorService } from 'shared/components/smart-advisor/smart-advisor.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    WorkWidgetHeaderModule,
    SvgIconModule,
    LoadingModule,
    AssistedBrowsingModule,
    ChatBoxModule,
    NanorepPanelModule,
    SmartAdvisorModule,
    CannedMessageModule,
    DiscussionsModule,
    VisitorHistoryModule,
    AssignmentHistoryModule,
    RefreshableFrameModule,
    SalesforceLaneModule,
    RemoteControlPanelModule,
    DetailedDataModule
  ],
  providers: [
    SmartAdvisorService
  ],
  declarations: [
    ChatWidgetComponent
  ],
  exports: [
    ChatWidgetComponent
  ]
})
export class ChatWidgetModule {}
